<template>
  <!-- 業務報告 親コンポーネント -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader>
        <h2>業務報告</h2>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="3">対象月 </CCol>
          <CCol sm="4">{{ year }} 年 {{ month }} 月 </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">申請ユーザ名 </CCol>
          <CCol sm="4">{{ user_name }} </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">更新日時 </CCol>
          <CCol sm="4">{{ updated_at }} </CCol>
        </CRow>
      </CCardBody>
      <CCardBody>
        <template v-if="callFlg">
          <CRow>
            <CCol>
              <label class="common-label">取引先企業名</label>
              <br />
              <label class="common-text">{{ client }}</label>
            </CCol>
            <CCol>
              <label class="common-label">協力会社</label>
              <br />
              <label class="common-text">{{ related }}</label>
            </CCol>
            <CCol>
              <label class="common-label">プロジェクト名</label>
              <br />
              <label class="common-text">{{ project }}</label>
            </CCol>
          </CRow>
          <hr />
          <CRow>
            <CCol>
              <label class="common-label">その他関連</label>
              <br />
              <label class="common-text">{{ otherRelated }}</label>
            </CCol>
            <CCol>
              <label class="common-label">契約形態</label>
              <br />
              <label class="common-text">{{ contract }}</label>
            </CCol>
            <CCol>
              <label class="common-label">その他契約事項</label>
              <br />
              <label class="common-text">{{ otherContract }}</label>
            </CCol>
          </CRow>
          <hr />
          <CRow>
            <CCol>
              <label class="common-label">始業時刻</label>
              <br />
              <label class="common-text">{{ startTime }}</label>
            </CCol>
            <CCol>
              <label class="common-label">終業時刻</label>
              <br />
              <label class="common-text">{{ endTime }}</label>
            </CCol>
            <CCol>
              <label class="common-label">休憩時間</label>
              <br />
              <label class="common-text">{{ breakTime }}</label>
            </CCol>
          </CRow>
          <hr />
          <CRow>
            <CCol>
              <label class="common-label">精算基準時間</label>
              <br />
              <label class="common-text">{{ baseTime }}</label>
            </CCol>
            <CCol>
              <label class="common-label">必要な資格・スキル</label>
              <br />
              <label class="common-text">{{ language }}</label>
            </CCol>
            <CCol>
              <label class="common-label">使用機材・ツール</label>
              <br />
              <label class="common-text">{{ otherTech }}</label>
            </CCol>
          </CRow>
        </template>
      </CCardBody>
      <template v-if="callFlg">
        <CCardHeader>
          <strong>詳細入力</strong>
        </CCardHeader>
        <CCardBody>
            <ReportError
              ref="error"
              :task="task"
              :plan_day="plan_day"
              :progress="progress"
              :plan_start="plan_start"
              :start_day="start_day"
              :plan_end="plan_end"
              :end_day="end_day"
              :details="details"
              :problem="problem"
              :cause="cause"
              :measures="measures"
              :total_time="total_time"
              :defined="defined"
              :expect_over="expect_over"
              :total_over="total_over"
              :total_night="total_night"
              :total_holiday="total_holiday"
              :over_reason="over_reason"
            ></ReportError>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th rowspan="2" width="210px" scope="col">項目*</th>
                    <th width="100px" scope="col">予定日数*</th>
                    <th width="130px" scope="col">開始予定*</th>
                    <th width="130px" scope="col">完了予定*</th>
                    <th colspan="5" width="90px" scope="col">先月(予定)</th>
                    <th colspan="5" width="90px" scope="col">今月(予定)</th>
                    <th colspan="5" width="95px" scope="col">来月(予定)</th>
                  </tr>
                  <tr>
                    <th scope="col">進捗率(%)*</th>
                    <th scope="col">開始日*</th>
                    <th scope="col">完了日</th>
                    <th colspan="5" scope="col">先月(実績)</th>
                    <th colspan="5" scope="col">今月(実績)</th>
                    <th colspan="5" scope="col">来月(実績)</th>
                  </tr>
                </thead>
                <tbody v-for="(n, index) in lists" :key="index">
                  <tr>
                    <td rowspan="2">
                      <ValidationProvider name="項目" rules="required">
                        <CTextarea
                          v-model="task[index]"
                          rows="4"
                          @blur="task_check"
                          style="width:200px;"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider
                        name="予定日数"
                        rules="required|numeric"
                      >
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-short"
                          append="日"
                          
                          v-model="plan_day[index]"
                          @blur="plan_day_check"
                        />
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider name="開始予定" rules="required|date">
                        <CInput
                          v-model="plan_start[index]"
                          @blur="plan_start_check"
                          style="width:100px;"
                        />
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider name="完了予定" rules="required|date">
                        <CInput
                          v-model="plan_end[index]"
                          @blur="plan_end_check"
                          style="width:100px;"
                        />
                      </ValidationProvider>
                    </td>
                    <!-- 色変更コンポーネント(青)呼出 -->
                    <td
                        v-for="(color, colorIndex) in blue[index].slice(0, 15)"
                        :key="colorIndex"
                        :style="{ background: color }"
                        @click="setBlue(colorIndex, index)"
                      ></td>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider name="進捗率" rules="required|date">
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-short"
                          append="%"
                          
                          v-model="progress[index]"
                          @blur="progress_check"
                        />
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider name="開始日" rules="required|date">
                        <CInput
                          v-model="start_day[index]"
                          style="width:100px;"
                          @blur="start_day_check"
                        />
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider name="完了日" rules="required|date">
                        <CInput
                          v-model="end_day[index]"
                          style="width:100px;"
                          @blur="end_day_check"
                        />
                      </ValidationProvider>
                    </td>
                    <!-- 色変更コンポーネント(黄)呼出 -->
                    <td
                        v-for="(color, colorIndex) in yellow[index].slice(0, 15)"
                        :key="colorIndex"
                        :style="{ background: color }"
                        @click="setYellow(colorIndex, index,end_day[index])"
                      ></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <CRow>
              <CCol>
                <table class="table table-bordered" width="100%">
                  <tr align="left">
                    <th class="red-asterisk">業務内容</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider name="業務内容" rules="required">
                        <CTextarea
                          rows="20"
                          v-model="details"
                          @blur="details_check"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                  </tr>
                  <tr align="left">
                    <th>問題点*</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider name="問題点" rules="required">
                        <CTextarea
                          rows="5"
                          v-model="problem"
                          @blur="problem_check"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                  </tr>
                  <tr align="left">
                    <th>原因*</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider name="原因" rules="required">
                        <CTextarea
                          rows="5"
                          v-model="cause"
                          @blur="cause_check"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                  </tr>
                  <tr align="left">
                    <th>対策*</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider name="対策" rules="required">
                        <CTextarea
                          rows="5"
                          v-model="measures"
                          @blur="measure_check"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
            <CCardHeader>
              <strong>当月</strong>
            </CCardHeader>
            <CRow>
              <CCol>
                <table class="table table-bordered">
                  <tr>
                    <th class="red-asterisk">勤務時間
                      <span :style="{ color: workTimeStatus.color, 'font-weight': 'bold', 'margin-left': '10px' }">
                        {{ workTimeStatus.text }}
                      </span>
                    </th>
                    <th class="red-asterisk">時間外時間</th>
                  </tr>
                  <td>
                    <ValidationProvider
                      :name="勤務時間"
                      rules="required|total_time"
                    >
                      <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                        append="h:m"
                        style="margin-bottom: 3px"
                        type="text"
                        maxlength="10"
                        v-model="total_time"
                        @blur="total_time_check"
                      />
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :name="時間外時間"
                      rules="required|total_time"
                    >
                      <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                        append="h:m"
                        style="margin-bottom: 3px"
                        type="text"
                        maxlength="10"
                        v-model="total_over"
                        @blur="total_over_check"
                      />
                    </ValidationProvider>
                  </td>
                  <tr>
                    <th class="red-asterisk">夜勤時間</th>
                    <th class="red-asterisk">法定休日時間</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider
                        :name="夜勤時間"
                        rules="required|total_time"
                      >
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                          append="h:m"
                          style="margin-bottom: 3px"
                          type="text"
                          maxlength="10"
                          v-model="total_night"
                          @blur="total_night_check"
                        />
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider
                        :name="法定休日時間"
                        rules="required|total_time"
                      >
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                          append="h:m"
                          style="margin-bottom: 3px"
                          type="text"
                          maxlength="10"
                          v-model="total_holiday"
                          @blur="total_holiday_check"
                        />
                      </ValidationProvider>
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
            <CCardHeader>
              <strong>勤務時間</strong>
            </CCardHeader>
            <CRow>
              <CCol>
                <table class="table table-bordered">
                  <tr>
                    <th class="red-asterisk">規定勤務時間</th>
                    <th
                      :class="{
                        'red-asterisk':
                          total_over !== '0:00' || total_over !== '00:00'
                      }"
                    >
                      時間外事由
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider
                        :name="規定勤務時間"
                        rules="required|total_time"
                      >
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                          append="h:m"
                          style="margin-bottom: 3px"
                          type="text"
                          maxlength="10"
                          v-model="defined"
                          @blur="defined_check"
                        />
                      </ValidationProvider>
                    </td>
                    <td rowspan="3">
                      <ValidationProvider
                        name="時間外発生理由"
                        :rules="{
                          required:
                            total_over !== '0:00' || total_over !== '00:00'
                        }"
                      >
                        <CTextarea
                          rows="6"
                          v-model="over_reason"
                          @blur="over_reason_check"
                        ></CTextarea>
                      </ValidationProvider>
                    </td>
                  </tr>
                  <tr>
                    <th class="red-asterisk">予定時間外時間</th>
                  </tr>
                  <tr>
                    <td>
                      <ValidationProvider
                        :name="予定時間外時間"
                        rules="required|total_time"
                      >
                        <CInput class="preika-control-frame--unit preika-control-frame--unit-time"
                          append="h:m"
                          style="margin-bottom: 3px"
                          type="text"
                          maxlength="10"
                          v-model="expect_over"
                          @blur="expect_over_check"
                        />
                      </ValidationProvider>
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
            <table class="table table-bordered">
              <tr>
                <th>連絡事項・要確認事項・確認依頼事項</th>
              </tr>
              <tr>
                <td>
                  <CTextarea rows="5" v-model="remarks"></CTextarea>
                </td>
              </tr>
            </table>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
<script>
import axios from "axios";
import moment from "moment";
import SetBlue from "./../../report/SetBlue";
import SetYellow from "./../../report/SetYellow";
import ReportError from "./../../report/ReportError";
import ConstList from '../../ConstList';
import { requestFailureMessage } from '@/utils/requestFailure';
import { leaveWhenDetailIsRefused } from '@/utils/detailReadRefused';
export default {
  name: "MonthlyReport",
  components: {
    SetBlue,
    SetYellow,
    ReportError
  },
  data() {
    return {
      id: "",
      year: "",
      month: "",
      date: "",
      writer: "",
      client: "",
      startTime: "",
      endTime: "",
      breakTime: "",
      related: "",
      project: "",
      projectList: [],
      otherRelated: "",
      company: "",
      companyList: [],
      contract: "",
      baseTime: "",
      base_time_min: null,
      base_time_max: null,
      otherContract: "",
      language: "",
      otherTech: "",
      num: 0,
      task: [],
      plan_day: [],
      plan_start: [],
      plan_end: [],
      blue: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        ]
      ],
      progress: [],
      start_day: [],
      end_day: [],
      yellow: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        ]
      ],
      details: "",
      problem: "",
      cause: "",
      measures: "",
      total_time: "",
      defined: "",
      expect_over: "",
      total_over: "",
      total_night: "",
      total_holiday: "",
      over_reason: "",
      remarks: "",
      user_name: "",
      updated_at: "",
      callFlg: false
    };
  },

  methods: {
    callList: function() {
      this.callFlg = false;
      this.user_id = this.$route.params.user_id;
      this.year = this.$route.params.year;
      this.month = this.$route.params.month;
      this.id = this.$route.params.id;
      axios
      .get(
        process.env.VUE_APP_API_ORIGIN +
          "/admin/monthlyReportSelect/" +
          this.id
      )
      .then(response => {
        if (!response.data.date) {
          alert("対象月のデータがないため、新規作成します。");
          this.callFlg = true;
          return;
        }
        this.task = [];
        this.plan_day = [];
        this.plan_start = [];
        this.plan_end = [];
        this.blue = [];
        this.progress = [];
        this.start_day = [];
        this.end_day = [];
        this.yellow = [];
        let n = 0;
        while (n < response.data.taskList.length) {
          this.task.push(response.data.taskList[n].task);
          this.plan_day.push(response.data.taskList[n].plan_day);
          this.plan_start.push(response.data.taskList[n].plan_start);
          this.plan_end.push(response.data.taskList[n].plan_end);
          this.progress.push(response.data.taskList[n].progress);
          this.start_day.push(response.data.taskList[n].start_day);
          this.end_day.push(response.data.taskList[n].end_day);

          let blueBar = [];
          let yellowBar = [];
          response.data.taskList[n].blue.split("").forEach(element => {
            if (element === "0") {
              blueBar.push("");
            } else {
              blueBar.push("blue");
            }
          });
          this.blue.push(blueBar);
          response.data.taskList[n].yellow.split("").forEach(element => {
            if (element === "0") {
              yellowBar.push("");
            } else if(response.data.taskList[n].end_day=='') {
              yellowBar.push("red");
            }else {
              yellowBar.push("yellow");
            }
          });
          this.yellow.push(yellowBar);
          this.num++;
          n++;
        }
        this.date = response.data.date;
        this.client = response.data.client;
        this.startTime = response.data.startTime;
        this.endTime = response.data.endTime;
        this.breakTime = response.data.breakTime;
        this.related = response.data.related;
        this.project = response.data.project;
        this.otherRelated = response.data.otherRelated;
        this.contract = response.data.contract;
        this.baseTime = response.data.baseTime;
        this.base_time_min = response.data.baseTimeMin
        this.base_time_max = response.data.baseTimeMax
        this.otherContract = response.data.otherContract;
        this.language = response.data.language;
        this.otherTech = response.data.otherTech;
        this.taskList = response.data.taskList;
        this.details = response.data.details;
        this.problem = response.data.problem;
        this.cause = response.data.cause;
        this.measures = response.data.measures;
        this.total_time = response.data.totalTime;
        this.defined = response.data.defined;
        this.expect_over = response.data.expectOver;
        this.total_over = response.data.totalOver;
        this.total_night = response.data.totalNight;
        this.total_holiday = response.data.totalHoliday;
        this.over_reason = response.data.overReason;
        this.remarks = response.data.remarks;
        this.updated_at = response.data.updatedAt;
        this.user_name = response.data.userName;
        this.callFlg = true;
      })
      .catch(error => {
        // 読み込みを断られたら、空の画面を残さず断りの画面へ移す。
        if (leaveWhenDetailIsRefused(this.$router, error)) return;
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
      });
    },
    setBlue: function(colorIndex, index) {
      if (this.blue[index][colorIndex] === "blue") {
        this.blue[index].splice(colorIndex, 1, "");
      } else {
        this.blue[index].splice(colorIndex, 1, "blue");
      }
    },
    setYellow: function(colorIndex, index,end) {
      if (this.yellow[index][colorIndex] === "yellow") {
        this.yellow[index].splice(colorIndex, 1, "");
      } else {
        if(end=='')  this.yellow[index].splice(colorIndex, 1, "red");
        else this.yellow[index].splice(colorIndex, 1, "yellow");
      }
    },
    task_check: function() {
      this.$refs.error.task_empty();
    },
    plan_day_check: function() {
      this.$refs.error.plan_day_empty();
      this.$refs.error.plan_day_regex();
    },
    progress_check: function() {
      this.$refs.error.progress_empty();
      this.$refs.error.progress_regex();
    },
    plan_start_check: function() {
      this.$refs.error.plan_start_empty();
      this.$refs.error.plan_start_regex();
    },
    start_day_check: function() {
      this.$refs.error.start_day_empty();
      this.$refs.error.start_day_regex();
    },
    plan_end_check: function() {
      this.$refs.error.plan_end_empty();
      this.$refs.error.plan_end_regex();
    },
    end_day_check: function() {
      this.$refs.error.end_day_regex();
    },
    details_check: function() {
      this.$refs.error.details_empty();
    },
    problem_check: function() {
      this.$refs.error.problem_empty();
    },
    cause_check: function() {
      this.$refs.error.cause_empty();
    },
    measure_check: function() {
      this.$refs.error.measure_empty();
    },
    total_time_check: function() {
      this.$refs.error.total_time_empty();
      this.$refs.error.total_time_regex();
    },
    defined_check: function() {
      this.$refs.error.defined_empty();
      this.$refs.error.defined_regex();
    },
    expect_over_check: function() {
      this.$refs.error.expect_over_empty();
      this.$refs.error.expect_over_regex();
    },
    total_over_check: function() {
      this.$refs.error.total_over_empty();
      this.$refs.error.total_over_regex();
    },
    total_night_check: function() {
      this.$refs.error.total_night_empty();
      this.$refs.error.total_night_regex();
    },
    total_holiday_check: function() {
      this.$refs.error.total_holiday_empty();
      this.$refs.error.total_holiday_regex();
    },
    over_reason_check: function() {
      this.$refs.error.over_reason_empty();
    },
    hmToMinutes(v) {
      if (v === null || v === undefined) return NaN;
      const s = String(v).trim();
      if (s === '') return NaN;

      // "H:MM" 形式
      if (s.includes(':')) {
        const [h, m = '0'] = s.split(':');
        const hh = Number(h);
        const mm = Number(m);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
        // 分が 60 以上でも一応吸収（例: "1:90" -> 150分）
        return hh * 60 + mm;
      }

      // "150"（時間）→ 分に
      const hh = Number(s);
      if (!Number.isFinite(hh)) return NaN;
      return hh * 60;
    },

    formatDiff(mins) {
      const abs = Math.abs(mins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      // 分は必ず2桁表示
      return `${h}:${m.toString().padStart(2, '0')}`;
    },
  },

  computed: {
    // 入力欄を追加・削除出来るようにする
    lists: function() {
      return Array.from(Array(this.num).keys());
    },
    workTimeStatus() {
      const totalMin = this.hmToMinutes(this.total_time);      // 例: "129:00" -> 7740
      const minMin   = this.hmToMinutes(this.base_time_min);   // 例: "150"   -> 9000
      const maxMin   = this.hmToMinutes(this.base_time_max);   // 例: "180"   -> 10800

      const hasTotal = Number.isFinite(totalMin);
      const hasMin   = Number.isFinite(minMin);
      const hasMax   = Number.isFinite(maxMin);

      // total が未入力/不正なら判定は表示しない（=基準時間内扱い）
      if (!hasTotal) return { text: '基準時間内', color: 'green' };

      // min/max 未設定なら「基準時間内」
      if (!hasMin && !hasMax) return { text: '基準時間内', color: 'green' };

      if (hasMax && totalMin > maxMin) {
        return { text: `超過：${this.formatDiff(totalMin - maxMin)}`, color: 'red' };
      }
      if (hasMin && totalMin < minMin) {
        return { text: `不足：${this.formatDiff(minMin - totalMin)}`, color: 'blue' };
      }
      return { text: '基準時間内', color: 'green' };
    },
  },
  mounted: function() {
    const today = moment();
    this.year = today.format("YYYY");
    this.month = today.format("M");
    this.callList();
  }
};
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
  
<style scoped>
th {
  white-space: nowrap;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

.common-label {
  font-size: 12px;
}

.common-text {
  font-size: 15px;
  font-family: "Sawarabi Gothic", sans-serif;
}
</style>
  